<mat-form-field appearance="outline" class="col-12">
  <mat-label>{{ 'Sellers.Products.CardNumber' | translate }}</mat-label>
  <div class="with-icon">
    <input [type]="fieldObject.fieldType"
           class="form-control"
           [formControl]="formControlRef"
           (keyup)="fieldLogicWork()"
           maxlength="{{maxlength}}"
           #ccNumber
           matInput
           dir="ltr"
           id="card-number"
           [name]="fieldObject.fieldName"
           [autocomplete]="fieldObject.autoCompleteName">
    <mat-icon fontSet="far" fontIcon="{{cardtype}}"></mat-icon>
  </div>
  <mat-error *ngIf="fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName]">
    {{ fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName] }}
  </mat-error>
  <mat-hint style="color: red;" *ngIf="cardErrors">
    {{cardErrors | translate }}
  </mat-hint>
</mat-form-field>


